// extracted by mini-css-extract-plugin
export default {"botaoDeletar":"styles_botaoDeletar__HAZAV"};